import { memo } from "react";
import { ListingLocation, MarketplaceDetails } from "services/api/sales/listings/types";
import { InfoCard, InfoGrid, Section } from "./primitives";
import ListingLocationCard from "./ListingLocationCard";

interface Props {
  details?: MarketplaceDetails | null;
  /** Adresa s karte — postoji samo ako je oglas ima spremljenu. */
  location?: ListingLocation | null;
  onLocationChange?: (location: ListingLocation) => void;
}

// Sekcija "Lokacija" — ista polja kao LocationSection na unosu (županija,
// općina, naselje, ručna adresa, prikaz na karti). Karta se dodaje ispod kad
// oglas ima spremljenu adresu; prije se cijela sekcija skrivala bez nje.
const ListingLocationSection: React.FC<Props> = ({ details, location, onLocationChange }) => {
  const displayText = details?.locationDisplay === "approximate"
    ? "Približna lokacija na karti"
    : details?.locationDisplay === "exact"
      ? "Točna lokacija na karti"
      : null;

  return (
    <Section title="Lokacija">
      <InfoGrid columns={3}>
        <InfoCard label="Županija / grad" value={details?.locationCountyCode} />
        <InfoCard label="Općina" value={details?.locationMunicipalityCode} />
        <InfoCard label="Naselje" value={details?.locationSettlementCode} />

        <InfoCard label="Adresa (ručno)" value={details?.locationManualAddress} colSpan={2} />
        <InfoCard label="Prikaz na karti" value={displayText} />
      </InfoGrid>

      {location && (
        <ListingLocationCard location={location} onLocationChange={onLocationChange} embedded />
      )}
    </Section>
  );
};

export default memo(ListingLocationSection);
